import Hijack from "../support/Hijack.js";
import RenaiEventAttendance from "../hacks/RenaiEventAttendance.js";
import useAuth from "../auth/useAuth.js";

import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Tooltip, Box, Tabs, TabPanel, Tab} from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Edit from '@material-ui/icons/Edit';
import LinkIcon from '@material-ui/icons/Link';

const previewStyles = makeStyles((theme) => ({
    
}));

function RenaiEventPagePreviewGrid({ pages, onSubmitAttendance }) {
    const classes = previewStyles();
    const [mode, setMode] = useState("calendar");

    const Pages = () => {
        if (mode === "calendar") {
            return <ul className={classes.collection}>
                {pages.map((p, i) => <PagePreviewRenaiEvent key={p.id} page={p} index={i} onSubmitAttendance={onSubmitAttendance} />)}
            </ul>;
        }

        return <ul className={classes.collection}>
            {pages.map((p, i) => <PagePreviewRenaiEvent key={p.id} page={p} index={i} onSubmitAttendance={onSubmitAttendance} />)}
        </ul>;
    };

    const handleChange = (e, v) => {
        console.log(v);
        setMode(v);
    };

    return <>
        <Tabs value={mode} indicatorColor="primary" textColor="primary" onChange={handleChange} aria-label="event view">
            <Tab label="Calendar" value={"calendar"} />
            <Tab label="List" value={"list"} />
        </Tabs>
        {Pages()}
    </>;
}

function MiniButton({ help, icon, link }) {
    return <Tooltip title={help}>
        <Button size="small" style={{ padding: '4px', margin: 0, color: 'var(--black)', minWidth: 'auto' }} color="primary" component={RouterLink} to={link}>{icon}</Button>
    </Tooltip>;
}

function PagePreviewRenaiEvent({ page, index, onSubmitAttendance }) {
    const auth = useAuth();
    const classes = previewStyles();

    const [canContribute, setCanContribute] = useState(false);
    const [canApprove, setCanApprove] = useState(false);

    useEffect(() => {
        if (page) {
            setCanContribute(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("renaissance_events.contributor") !== -1);
            setCanApprove(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("renaissance_events.approver") !== -1);
        }
    }, [auth, page]);

    return <li className={classes.hex} style={{ animationDelay: `${index * 60}ms` }} >
        <Chip label={"TODO dates"} variant="outlined" size="small" style={{ margin: 0, padding: 0, fontSize: 8 }} />
        {page?.title}
        {canContribute ? <MiniButton help="Make changes to the page" icon={<Edit />} link={"/" + page.area + "/" + page.id + "/edit"} />  : ""}
        {canApprove ? <MiniButton help="View page" icon={<LinkIcon />} link={"/" + page.area  + "/" + (page.url || page.family)} /> : null}
        {page.state == "workflow" ? (<Chip label={"Workflow"} variant="outlined" size="small" style={{ margin: 0, padding: 0, fontSize: 8 }} />) : ""}
        {page.redirect ? (<Chip label={"Redir"} className={classes.chipWarn} size="small" style={{ margin: 0, padding: 0, fontSize: 8 }} />) : ""}
        <RenaiEventAttendance page={page} mini onSubmitAttendance={onSubmitAttendance} /> todo after start date?
    </li>;
}

export { PagePreviewRenaiEvent, RenaiEventPagePreviewGrid };
